/* eslint-disable @typescript-eslint/no-explicit-any */
import { Flex, Menu } from 'antd';
import BKGlobalLayout from 'components/bank/AGBBank/GlobalLayout';

import { Link } from 'react-router-dom';
import { IAccountInfo } from 'interfaces/queries/account';
import TransferOptions from './TransferOptions';
import useConfirmWithPIN from 'hooks/useConfirmWithPIN';
import PINModal from 'components/shared/PINModal';
import Account from './Account';
import { useState } from 'react';
import { AccountPageConfigurations } from 'assets/customStyle/AccountStyle';
import useMediaQuery, {
  useScreenStyle,
  ScreenType,
} from 'hooks/styleMediaQuery/useMediaQuery';
import AccountMessage from 'components/bank/AGBBank/AccountMessage/AccountMessage';

type AccountPage = 'Account List' | 'Account Details';

export const containerSize = { width: '100%' };

export const menuItems: any = (
  translate: (_text: string) => string,
  handleOpenDrawer: (_drawerTitle: string) => void,
) => {
  return (
    <Menu className="local-dropdown">
      <Menu.Item key="1">
        <Link to={''} onClick={() => handleOpenDrawer('AGB to AGB')}>
          {translate('To AGB')}
        </Link>
      </Menu.Item>
      <Menu.Item key="3">
        <Link
          onClick={() => handleOpenDrawer('Between own accounts')}
          to={''}
        >
          {translate('Between own accounts')}
        </Link>
      </Menu.Item>
      <Menu.Item key="4">
        <Link
          onClick={() => handleOpenDrawer('To Another Bank Account')}
          to={''}
        >
          {translate('To Another Bank Account')}
        </Link>
      </Menu.Item>
      <Menu.Item key="5">
        <Link onClick={() => handleOpenDrawer('Operators')} to={''}>
          {translate('To Mobile Operator')}
        </Link>
      </Menu.Item>
    </Menu>
  );
};

const AccountsPage: React.FC<{
  userData: any;
  accountNumbers: IAccountInfo[];
  loadingAccountNumbers: boolean;
  getStatement: any;
  updateTransactionLimitOption: any;
  filterTransactionsData: any;
  loadTransaction: boolean;
  selectedAccount: any;
  setSelectedAccount: any;
}> = ({
  userData,
  accountNumbers,
  getStatement,
  updateTransactionLimitOption,
  filterTransactionsData,
  loadTransaction,
  selectedAccount,
  setSelectedAccount,
}) => {
  const accounts = accountNumbers;
  const screen = useMediaQuery();
  const screenType = screen as ScreenType;
  const style = useScreenStyle(screenType, AccountPageConfigurations);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [nextPage, setNextPage] =
    useState<AccountPage>('Account Details');

  const {
    isInSightBalanceVisible,
    loadCheckUSerPIN,
    onPINValuesChange,
    transactionSummaryData,
    openModel,
    form,
    pin,
    onHandleCloseModal,
    onHandleOpenModal,
    handleToggleVisibility,
    handleToggleHideInsight,
    MonthName,
  } = useConfirmWithPIN({
    userData: userData,
    selectedAccount: selectedAccount,
  });

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const onHandleBackTo = () => {
    setNextPage('Account List');
  };

  return (
    <BKGlobalLayout height={'100%'}>
      <div
        size={screenType === 'mobile' ? 'small' : 'default'}
        {...style.mainBox}
      >
        {userData?.[0]?.AccountVerified !== 'NO' ? (
          <Flex
            gap="middle"
            align="start"
            justify="space-between"
            className="small-padding"
            vertical
          >
            <Flex gap="small" vertical style={{ ...containerSize }}>
              {nextPage === 'Account Details' && (
                <Account
                  selectedAccount={selectedAccount}
                  setSelectedAccount={setSelectedAccount}
                  accountNumbers={accounts}
                  userData={userData}
                  updateTransactionLimitOption={
                    updateTransactionLimitOption
                  }
                  loadTransaction={loadTransaction}
                  filterTransactionsData={filterTransactionsData}
                  getStatement={getStatement}
                  onHandleBackTo={onHandleBackTo}
                  MonthName={MonthName}
                  isInSightBalanceVisible={isInSightBalanceVisible}
                  onHandleOpenModal={onHandleOpenModal}
                  handleToggleHideInsight={handleToggleHideInsight}
                  transactionSummaryData={transactionSummaryData}
                />
              )}
            </Flex>
          </Flex>
        ) : (
          <AccountMessage
            type="warning"
            className="message-container-full"
          />
        )}
      </div>
      <TransferOptions
        isModalOpen={isModalOpen}
        handleClose={handleClose}
      />
      <PINModal
        open={openModel}
        onClose={onHandleCloseModal}
        onValuesChange={onPINValuesChange}
        isLoading={loadCheckUSerPIN}
        onHandleConfirm={handleToggleVisibility}
        form={form}
        pin={pin}
      />
    </BKGlobalLayout>
  );
};

export default AccountsPage;
